<template>
  <div class="PatienDetail">
    <div class="topTitle">
      <p>电子病历</p>
      <!-- <Button @click="newCase">补写病历</Button> -->
      <Button @click="backList">返回列表</Button>
    </div>
    <div class="mainBox">
       <div>
         <span>{{name}}</span>
         <Button type="text" ghost custom-icon="iconfont icon-bianji" @click="editBasic">编辑</Button>
       </div>
       <div class="mainInfo">
        <ul>
           <li>
             <span>病案号：</span>
             <span v-if="patientNo">{{patientNo}}</span>
           </li>
           <li>
             <span>性别：</span>
             <span v-if="sex">{{sex}}</span>
           </li>
           <li>
             <span>年龄：</span>
             <span v-if="age||ageUnit">{{age}}{{ageUnit}}</span>
           </li>
           <li>
             <span>手机号：</span>
             <span v-if="mobile">{{mobile}}</span>
           </li>
           <li>
             <span>身份证号：</span>
             <span v-if="idNumber">{{idNumber}}</span>
           </li>
           <li>
             <span>住址：</span>
             <span v-if="address">{{address}}</span>
           </li>
         </ul>
       </div>
      </div>
    <div>
    <Tabs type="card">
      <TabPane label="诊断记录">
        <div class="newCase" @click="addCase">
          <span >
            <i class="iconfont icon-jia"></i>
            新建病历
          </span>
        </div>
        <div class="casePanel" v-for="(item,ind) in hisCaseOneVoList" v-bind:key="ind">
          <ul>
            <li>
              <span class="diga">{{item.diagnosis}}</span>
              <span>{{item.time}}</span>
            </li>
            <li>
              <p>{{item.performance}}</p>
            </li>
          </ul>
        </div>
      </TabPane>
      <TabPane label="检测记录">
        <div class="proPanel" v-for="(item,ind) in hisProjectOneVos" v-bind:key="ind">
          <ul>
            <li>
              <span class="diga">{{item.diagnosis}}</span>
              <span>{{item.time}}</span>
            </li>
            <li>
              <p v-for="(pro,subIndex) in item.hospitalCaseProjects" :key="subIndex">
                <span>{{pro.hospitalProjectName}}</span>
                <span>({{pro.state|payState}})</span>
              </p>
            </li>
          </ul>
        </div>
      </TabPane>
    </Tabs>
    </div>
  </div>
</template>

<script>
import {
  patientDetail
} from "../../api/patient";
import { tips,replaceT,payType,payState } from "../../tools";

export default {
  name: 'PatientDetail',
  data () {
    return {
      detailId:0,//患者id
      address:'',//地址
      age:0,//年龄
      ageUnit:'',//年龄单位
      idNumber:0,//身份证号
      mobile:0,//手机号
      name:'',//患者名称
      sex:'',//性别
      patientNo:0,//病案号
      hisCaseOneVoList:[],//诊断记录
      hisProjectOneVos:[],//检测记录
    }
  },
  mounted(){
    this.detailId = this.$route.query.id;
    this.patientDetail();
  },
  filters:{
    payState:function(val){
      return payState(val);
    }
  },
  methods:{
    //患者详情
    patientDetail(){
      let _this = this;
      patientDetail({
        id:_this.detailId
      }).then(res => {
        console.log(res);
        _this.address = res.address;
        _this.age = res.age;
        _this.ageUnit = res.ageUnit;
        _this.idNumber = res.idNumber;
        _this.mobile = res.mobile;
        _this.name = res.name;
        _this.sex = res.sex==1?'男':'女';
        _this.patientNo = res.patientNo;
        _this.hisCaseOneVoList = res.hisCaseOneVoList;
        _this.hisProjectOneVos = res.hisProjectOneVos;
      });
    },
    //补写病历
    newCase(){
      this.$router.push({path:'cliniclist',query:{patientId:this.detailId}});
    },
    //新建病历
    addCase(){
      this.$router.push({path:'cliniclist',query:{patientId:this.detailId}});
    },
    //返回列表
    backList(){
      this.$router.push({path:'patientmanager'})
    },
    //编辑患者基本信息
    editBasic(){
      this.$router.push({path:'addpatient',query:{editId:this.detailId}});
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
.PatienDetail{
  width: 100%;
}
.topTitle{
  display: flex;
  justify-content: flex-start;
  padding: 10px;
  border: 1px solid #c9c9c9;
  border-left:none;
  border-right:none;
}
.topTitle>p{
  height: 32px;
  line-height: 32px;
  color: black;
  font-weight: bold;
}
.topTitle>button{
  margin-left: 10px;
}
.mainBox{
  padding: 10px;
  border-bottom: 1px solid #c9c9c9;
}
.mainBox>div:first-child{
  height: 40px;
  line-height: 40px;
}
.mainBox>div:first-child>span{
  color:#2778E7;
  font-weight: bold;
}
.mainBox>div:first-child>button{
  color:#2D8cF0;
}
.mainInfo{
  width: 100%;
}
.mainInfo>ul{
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap row;
}
.mainInfo>ul>li{
  height: 30px;
  line-height: 30px;
  margin-left: 30px;
}
.mainInfo>ul>li>span{
  font-size: 14px;
}
.mainInfo>ul>li>span:last-child{
  padding-right: 30px;
  border-right:1px solid #c9c9c9;
}
.mainInfo>ul>li>span:first-child{
  color:#7d88a6;
}
.ivu-tabs{
  margin-top: 15px;
}
.ivu-tabs .newCase{
  width: 240px;
  max-height: 150px;
  min-height: 110px;
  overflow: scroll;
  /* line-height: 80px; */
  border: 1px solid #c9c9c9;
  border-radius:5px; 
  text-align: center;
}
.ivu-tabs .newCase:hover{
  background-color: #1955A8;
}
.ivu-tabs .newCase:hover>span{
  color: #fff;
}
.ivu-tabs .newCase>span{
  display: inline-block;
  color: #1955A8;
  margin-top: 13%;
}
.ivu-tabs-tabpane{
  padding: 15px;
  display: flex;
  justify-content: flex-start;
  flex-flow: wrap row;
}
.ivu-tabs-tabpane>div{
  width: 23%;
  min-width: 240px;
  max-height: 150px;
  min-height: 110px;
  overflow: scroll;
  border: 1px solid #c9c9c9;
  border-radius:5px; 
  padding: 15px;
  cursor: pointer;
  margin: 10px 10px 0 0;
}
.ivu-tabs-tabpane>div.casePanel{
  border-left:3px solid #1955A8;
}
.ivu-tabs-tabpane>div.casePanel>ul>li:first-child{
  display: flex;
  justify-content: space-between;
  flex-flow: nowrap row;
  margin-bottom: 15px;
}
.ivu-tabs-tabpane>div.casePanel>ul>li>.diga{
  display: inline-block;
  overflow:hidden;
  word-break:keep-all;
  white-space:nowrap;
  text-overflow:ellipsis;
  width: 60%;
  font-weight: bold;
}
.ivu-tabs-tabpane>div.casePanel>ul>li>span{
  color:#7d88a6;
}
.ivu-tabs-tabpane>div.casePanel>ul>li>p{
  overflow:hidden;
  word-break:keep-all;
  white-space:nowrap;
  text-overflow:ellipsis;
}

.ivu-tabs-tabpane>div.proPanel{
  border-left:3px solid #909299;
}
.ivu-tabs-tabpane>div.proPanel>ul>li:first-child{
  display: flex;
  justify-content: space-between;
  flex-flow: nowrap row;
  margin-bottom: 15px;
}
.ivu-tabs-tabpane>div.proPanel>ul>li>.diga{
  display: inline-block;
  overflow:hidden;
  word-break:keep-all;
  white-space:nowrap;
  text-overflow:ellipsis;
  width: 60%;
  font-weight: bold;
}
.ivu-tabs-tabpane>div.proPanel>ul>li>span{
  color:#7d88a6;
}
.ivu-tabs-tabpane>div.proPanel>ul>li>p{
  display: flex;
  flex-flow: wrap row;
}
/* .ivu-tabs-tabpane>div.proPanel>ul>li>p>span{
  overflow:hidden;
  word-break:keep-all;
  white-space:nowrap;
  text-overflow:ellipsis;
} */
</style>



// WEBPACK FOOTER //
// src/views/patient/PatientDetail.vue